






















































import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { sleep, shuffle } from "../utils";
import * as api from '../api'
import App from '../App'
import { remoteOp } from "../helper";

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

type Model = {id: number, name: string, create_time: number, update_time, number}

interface DoneState {
  kind: 'done';
  items: Model[];
}

type State = UnsetState | ErrorState | DoneState

@Component
export default class AdministratorList extends Vue {

  state: State = {kind: 'unset'}

  loading = false

  busy = false

  get status() {
    return this.state.kind
  }

  toCreate() {
    this.$router.replace({ name: 'administrator-create' })
  }

  getUpdateLink(id: number) {
    let router = this.$router
    let route = this.$route
    let location = {
      name: 'administrator-update',
      params: {id: id.toString()}
    }
    return router.resolve(location, route).href
  }

  get items(): ReadonlyArray<Model> {
    if (this.state.kind === 'done') {
      let state = this.state
      return state.items
    }
    else
      throw new Error('runtime error.')
  }

  get callbacks() {
    let append = (item: Model) => {
      if (this.state.kind === 'done') {
        this.state.items.push(item)
      }
    }
    let update = (id, newValue: any) => {
      if (this.state.kind === 'done') {
        let old = this.state.items.find(item => item.id === id)
        if (old) {
          for (let k in newValue) {
            if ((old as Object).hasOwnProperty(k)) {
              old[k] = newValue[k]
            }
          }
        }
      }
    }
    return { append, update }
  }

  created() {
    this.reset()
  }

  async reset() {
    await sleep(0)
    this.loading = true
    try {
      let result = await api.invoke('administrator/ls')
      this.state = {
        kind: 'done',
        items: result,
      }
      this.loading = false
    }
    catch (e) {
      this.state = {kind: 'error', message: (e as Error).message}
      this.loading = false
    }
  }

  async remove(event: MouseEvent, id: number) {
    if (this.state.kind !== 'done')
      return
    let state = this.state
    let app = this.$root.$children[0] as App
    let el = event.srcElement!.parentElement!.parentElement!
    if (await app.exposeAndConfirm(el, '删除操作不可恢复, 是否继续?')) {
      remoteOp(this, '删除', '', async () => {
        await api.invoke('administrator/delete', id)
        let index = state.items.findIndex(n=>n.id == id)
        if (index !== -1)
          state.items.splice(index, 1)
      }, 880)
    }
  }
}
